Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
Controller = require 'app/scripts/controller'
{ getKey, Key } = require '@trello/keybindings'
ModelLoader = require 'app/scripts/db/model-loader'
PopOver = require 'app/scripts/views/lib/pop-over'
{ maybeDisplayLimitsErrorOnCardAdd } = require 'app/scripts/views/card/card-limits-error'
l = require 'app/scripts/lib/localize'
LabelLimitsErrorView = require 'app/scripts/views/label/label-limits-error-view'
SelectCardPosition = require 'app/scripts/views/card/select-card-position'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
parseURL = require 'url-parse'
f = require 'effing'
_ = require 'underscore'

module.exports = mixin SelectCardPosition, class CardCopyView extends View
  viewTitleKey: 'copy card'

  initialize: (opts) ->
    @onCopy = opts.onCopy ? (->)

  showCurrentPosition: true

  events:
    'change .js-select-position': 'renderValues'
    'change .js-select-list': 'updatePositionList'
    'change .js-select-board': 'updateBoardData'

    'keydown textarea[name="name"]': 'keydownEvent'
    'click .js-submit': 'submit'
    'submit form': 'submit'

  render: ->
    data = @model.toJSON()
    data.numChecklists = @model.checklistList.length
    data.numMembers = data.idMembers.length
    data.numLabels = data.idLabels?.length ? 0
    data.numAttachments = data.badges.attachments
    data.numComments = data.badges.comments
    data.numStickers = data.stickers.length

    data.hasChecklists = data.numChecklists > 0
    data.hasMembers = data.idMembers.length > 0
    data.hasLabels = data.numLabels > 0
    data.hasAttachments = data.badges.attachments > 0
    data.hasStickers = data.stickers.length > 0

    # Don't show option to copy comments hidden on templates
    data.hasComments = data.badges.comments > 0  && !@model.getBoard().isTemplate()

    data.hasStuff = (
      data.hasChecklists ||
      data.hasMembers ||
      data.hasLabels ||
      data.hasAttachments ||
      data.hasComments ||
      data.hasStickers
    )

    data.loading = @loading

    currentBoard = @model.getBoard()
    enterprise = @model.getBoard().getEnterprise()

    # Don't allow guests on enterprise owned boards to copy cards off the current board
    isGuest = currentBoard.isGuest(Auth.me())

    if isGuest && currentBoard.get('enterpriseOwned')
      data.isCopy = true
      data.hasEnterprise = true
      data.enterpriseName = enterprise?.get('displayName')
      data.restrictToCurrentBoard = true
      data.organizations = [
        {
          displayName: currentBoard.getOrganization()?.get('displayName') || l('member boards.boards'),
          boards: [
            _.extend(currentBoard.toJSON(), { selected: true })
          ]
        }
      ]
    else if enterprise?
      data.isCopy = true
      data.hasEnterprise = enterprise?
      data.organizations = Auth.me().getOpenBoardsInEnterpriseByOrg(true, enterprise.get('id'))
      data.enterpriseName = enterprise.get('displayName')
    else
      currentBoard = if @model.getBoard().isEditableByTeamMemberAndIsNotABoardMember() then currentBoard else null
      data.organizations = Auth.me().getOpenBoardsByOrg(true, currentBoard)

    for org in data.organizations
      for board in org.boards
        if board.id == @model.get('idBoard')
          board.selected = true

    partials =
      'move_card_controls': templates.move_card_controls

    @$el.html(
      templates.fill(
        'card_copy',
        data,
        { editable: @model.editable() },
        partials
      )
    )

    @updateBoardData()

    @

  getData: ->
    @loading = true

    Promise.all([
      ModelLoader.loadCardCopyData(@model.get('idBoard'), @model.id),
      ModelLoader.loadBoardMinimal(@model.get('idBoard'))
    ])
    .finally =>
      @loading = false
      @render()

  keydownEvent: (e) ->
    if getKey(e) == Key.Enter
      Util.stop(e)
      @submit(e)
      return

  submit: (e) ->
    Util.stop(e)

    nameInput = @$('textarea[name="name"]')

    # return if the user hasn't entered a title
    if nameInput.val().trim() == ''
      nameInput.focus().select()
      return

    idListSelected = @$('.js-select-list').find('option:selected').val()
    idBoardSelected = @$('.js-select-board').find('option:selected').val()
    boardSelected = @modelCache.get('Board', idBoardSelected)
    listSelected = boardSelected?.listList.get(idListSelected)
    options = {
      $elem: @$(e.target),
      hasChecklists: @model.checklistList.length > 0,
      hasAttachments: @model.attachmentList.length > 0,
      destinationBoard: boardSelected,
      destinationList: listSelected,
    }
    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    mandatoryFieldsToKeep = ['due']
    optionalFieldsToKeep = @$('input:checkbox:checked').get().map f.get('name')
    fieldsToKeep = mandatoryFieldsToKeep.concat(optionalFieldsToKeep)

    if idBoardSelected != @model.getBoard().id
      hasLabels = @model.getLabels().length > 0 && _.contains(fieldsToKeep,
        "labels"
      )
      if hasLabels && boardSelected.isOverLimit('labels', 'perBoard')
        PopOver.pushView(new LabelLimitsErrorView())
        return

    # prevent card copy spamming
    @$('.js-submit').attr('disabled', 'disabled')

    @model.copyTo
      name: nameInput.val().trim()
      idList: idListSelected
      pos: @$('.js-select-position').find('option:selected').val()
      keepFromSource: fieldsToKeep
    .then =>
      PopOver.hide()
      @onCopy()
      track("Card", "Copy Card")
      if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
        Analytics.sendTrackEvent
          action: 'copied'
          actionSubject: 'card'
          source: 'copyCardInlineDialog'
          containers:
            card:
              id: @model.id
            board:
              id: @model.getBoard().id
          attributes:
            isCardTemplate: !!@model.get('isTemplate')
            isBoardTemplate: @model.getBoard().isTemplate()
    .catch (e) =>
      PopOver.hide()
      Alerts.flash('could not copy card', 'error', 'create error')
      if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
        Analytics.sendOperationalEvent
          action: 'failed'
          actionSubject: 'cardCopy'
          source: 'copyCardInlineDialog'
          containers:
            card:
              id: @model.id
            board:
              id: @model.getBoard().id
          attributes:
            isCardTemplate: !!@model.get('isTemplate')
            isBoardTemplate: @model.getBoard().isTemplate()

    return
